/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FanStatistic } from '../models/FanStatistic';
import type { Statistics } from '../models/Statistics';
import type { StatisticsRange } from '../models/StatisticsRange';
import type { UpdateLinkClicksForm } from '../models/UpdateLinkClicksForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StatisticsService {
    /**
     * Update link clicks
     * Update the link clicks of a statistic entry.
     *
     * @returns any The link clicks have been updated.
     * @throws ApiError
     */
    public static updateLinkClicks({
        creatorId,
        requestBody,
    }: {
        /**
         * Id of the creator
         */
        creatorId: number,
        requestBody: UpdateLinkClicksForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/statistics/creator/{creatorId}/clicks',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request body`,
                403: `No privileged access to creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Find creators statistics
     * Finds creators statistics in the given date range.
     *
     * @returns Statistics The creator statistics
     * @throws ApiError
     */
    public static findCreatorsStatisticsV2({
        creatorId,
        from,
        to,
        zoneOverwrite,
    }: {
        /**
         * Ids of the creator. They are specified by repeatedly using the `&creatorId=...` query.
         */
        creatorId: Array<number>,
        /**
         * The start date of the period
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
        zoneOverwrite?: string,
    }): CancelablePromise<Statistics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/statistics/creator',
            query: {
                'creatorId': creatorId,
                'from': from,
                'to': to,
                'zoneOverwrite': zoneOverwrite,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Find statistics range
     * Returns the date range between the first and last statistics entry of a
     * creator or an owner. Therefore, provide a `creatorId` to receive the
     * date range of a creator and not the owner (associated to the executing user).
     *
     * @returns StatisticsRange The date range of the available statistics
     * @throws ApiError
     */
    public static findStatisticsRange({
        creatorId,
    }: {
        /**
         * Id of the creator
         */
        creatorId?: number,
    }): CancelablePromise<StatisticsRange> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/statistics/range',
            query: {
                'creatorId': creatorId,
            },
            errors: {
                403: `No privileged access to creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Find overview statistics
     * Finds statistics for all creators (with required license and the user has
     * access to) in the given date range.
     *
     * @returns Statistics The creator statistics
     * @throws ApiError
     */
    public static findOverviewStatistics({
        from,
        to,
    }: {
        /**
         * The start date of the period
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
    }): CancelablePromise<Statistics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/statistics/overview',
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                403: `No permission for this feature for any valid creator.`,
            },
        });
    }
    /**
     * Find overview fan statistics
     * Finds fan statistics for all creators (with required license and the user has
     * access to) in the given date range.
     *
     * @returns FanStatistic The overview fan statistics
     * @throws ApiError
     */
    public static findOverviewFanStatistics({
        from,
        to,
        desc = true,
        page,
        limit = 50,
    }: {
        /**
         * The start date of the period
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
        /**
         * Boolean whether the fans should be sorted by their total spend descending or ascending. By default: `true`.
         */
        desc?: boolean,
        /**
         * The page of the paginated request. Must be greater than or equal than 0. By default: 0.
         */
        page?: number,
        /**
         * The limit (amount of entries per request) of the paginated request. Must be between 1 and 50. By default: 50.
         */
        limit?: number,
    }): CancelablePromise<Array<FanStatistic>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/statistics/overview/fan',
            query: {
                'from': from,
                'to': to,
                'desc': desc,
                'page': page,
                'limit': limit,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Find creators statistics
     * Finds creators statistics in the given date range.
     *
     * @returns Statistics The creator statistics
     * @throws ApiError
     */
    public static findCreatorsStatistics({
        creatorId,
        from,
        to,
        zoneOverwrite,
    }: {
        /**
         * Ids of the creator. They are specified by repeatedly using the `&creatorId=...` query.
         */
        creatorId: Array<number>,
        /**
         * The start date of the period
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
        zoneOverwrite?: string,
    }): CancelablePromise<Statistics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/statistics/creator',
            query: {
                'creatorId': creatorId,
                'from': from,
                'to': to,
                'zoneOverwrite': zoneOverwrite,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Find creator fan statistics
     * Finds fan statistics in the given date range.
     *
     * @returns FanStatistic The creator fan statistics
     * @throws ApiError
     */
    public static findCreatorFanStatistics({
        creatorId,
        from,
        to,
        desc = true,
        page,
        limit = 50,
    }: {
        /**
         * Id of the creator
         */
        creatorId: number,
        /**
         * The start date of the period
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
        /**
         * Boolean whether the fans should be sorted by their total spend descending or ascending. By default: `true`.
         */
        desc?: boolean,
        /**
         * The page of the paginated request. Must be greater than or equal than 0. By default: 0.
         */
        page?: number,
        /**
         * The limit (amount of entries per request) of the paginated request. Must be between 1 and 50. By default: 50.
         */
        limit?: number,
    }): CancelablePromise<Array<FanStatistic>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/statistics/creator/{creatorId}/fan',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'from': from,
                'to': to,
                'desc': desc,
                'page': page,
                'limit': limit,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Get customer lifetime value for a given time range
     * Get customer lifetime value for a given time range.
     *
     * @returns number The customer lifetime value for a given time range
     * @throws ApiError
     */
    public static calculateCustomerLifetimeValue({
        creatorId,
        from,
        to,
    }: {
        /**
         * Id of the creator
         */
        creatorId: number,
        /**
         * The start date of the period
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
    }): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/statistics/creator/{creatorId}/clv',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
}
